const ShortExperiences = {
  shrtExperience: [
    {
      id: 1,
      experience: 'Wine-tasting',
    },
    {
      id: 2,
      experience: "Chef's Tables",
    },
    {
      id: 3,
      experience: 'Cookouts',
    },
    {
      id: 4,
      experience: 'In-home dining',
    },
    {
      id: 5,
      experience: 'Farm to Fork journeys',
    },
    {
      id: 6,
      experience: 'Tea-tasting',
    },
    {
      id: 7,
      experience: 'Coffee-roasting',
    },
    {
      id: 8,
      experience: 'Story-telling with a meal',
    },
    {
      id: 9,
      experience: 'Food Walks',
    },
  ],
  longDurationExperience: [
    {
      id: 10,
      lgExp: 'Plantation stays',
    },
    {
      id: 11,
      lgExp: 'Culinary Home-stays',
    },
    {
      id: 12,
      lgExp: 'Food Trails',
    },
  ],
};
export default ShortExperiences;
